export default {
  data() {
    return {
      celebrityNames: [
        'Joe Rogan',
        'Steve Jobs',
        'Jennifer Aniston',
        'Tom Hanks',
        'Will Smith',
        'George Clooney',
        'Brad Pitt',
        'Tom Cruise',
        'Chris Hemsworth',
        'David Beckham',
        'Dwayne Johnson',
        'Kevin Hart'
      ]
    }
  },

  computed: {
    namePlaceholder() {
      let names = this.celebrityNames
      return `e.g. ${names[Math.floor(Math.random() * names.length)]}`
    }
  }
}
